import React, { useState, useEffect, useContext } from "react";
import * as Icon from "react-bootstrap-icons";
import { Link } from "react-router-dom";
import { CmsContext } from "../context/CmsContext";

const Footer = () => {
  const { cmsData, fetchCmsData, loading } = useContext(CmsContext);
  const companyName =
    process.env.REACT_APP_COMPANY_NAME || "Affiliate Private Limited";

  useEffect(() => {
    fetchCmsData();
  }, [fetchCmsData]);

  const stripHtmlTags = (html) => {
    // Remove HTML tags using regex
    return html.replace(/<[^>]*>/g, "");
  };

  const getShortenedAboutUs = (text) => {
    if (text) {
      // Strip HTML tags first
      const cleanText = stripHtmlTags(text);
      // Split the text into words
      const words = cleanText.split(" ");
      // Limit to 10 words
      if (words.length > 10) {
        return words.slice(0, 10).join(" ") + "...";
      }
      return cleanText;
    }
    return "";
  };

  return (
    <div className="">
      <div className="footerbgcolor">
        <div className="footer container p-4 pb-0 text-white">
          <div className="row mt-3 pb-3">
            <div className="col-lg-4 p-3">
              <h6>{companyName}</h6>
              <p className="footer-text">
                {loading ? "Loading..." : getShortenedAboutUs(cmsData.aboutUs)}{" "}
                {!loading && cmsData.aboutUs && (
                  <Link to="/about-us" className="text-white ms-2">
                    Read More
                  </Link>
                )}
              </p>
              <div className="social mt-2">
                {cmsData?.facebookLink && (
                  <Link to={cmsData?.facebookLink} target="_blank">
                    <Icon.Facebook color="#fff" size={15} className="me-3" />
                  </Link>
                )}
                {cmsData?.instagramLink && (
                  <Link to={cmsData?.instagramLink} target="_blank">
                    <Icon.Instagram color="#fff" size={15} className="me-3" />
                  </Link>
                )}
                {cmsData?.youtubeLink && (
                  <Link to={cmsData?.youtubeLink} target="_blank">
                    <Icon.Youtube color="#fff" size={15} />
                  </Link>
                )}
              </div>
            </div>
            <div className="col-lg-8">
              <div className="row p-3 footerheadinggap">
                <div className="col-lg-3 mb-lg-0 mb-md-3 mb-3">
                  <h6>About Company</h6>
                  <ul className="m-0 p-0 list">
                    <li className="mb-lg-3 mb-md-2 mb-2 p-1">
                      <Link
                        to="/about-us"
                        className="nav-link text-dark footer-text"
                      >
                        About us
                      </Link>
                    </li>
                    <li className="mb-lg-3 mb-md-2 mb-2 p-1">
                      <Link
                        to="/what-we-do"
                        className="nav-link text-dark footer-text"
                      >
                        What we do
                      </Link>
                    </li>
                  </ul>
                </div>

                <div className="col-lg-3 mb-lg-0 mb-md-3 mb-3">
                  <h6>Legal and Policies</h6>
                  <ul className="m-0 p-0 list">
                    <li className="mb-lg-3 mb-md-2 mb-2 p-1">
                      <Link
                        to="/terms"
                        className="nav-link text-dark footer-text"
                      >
                        Terms and condition
                      </Link>
                    </li>
                    <li className="mb-lg-3 mb-md-2 mb-2 p-1">
                      <Link
                        to="/policy"
                        className="nav-link text-dark footer-text"
                      >
                        Privacy policy
                      </Link>
                    </li>
                  </ul>
                </div>
                <div className="col-lg-3 mb-lg-0 mb-md-3 mb-3">
                  <h6>Follow us</h6>
                  <ul className="m-0 p-0 list">
                    {cmsData?.facebookLink && (
                      <li className="mb-lg-3 mb-md-2 mb-2 p-1">
                        <Link
                          to={cmsData?.facebookLink}
                          target="_blank"
                          className="nav-link text-dark footer-text"
                        >
                          Facebook
                        </Link>
                      </li>
                    )}
                    {cmsData?.instagramLink && (
                      <li className="mb-lg-3 mb-md-2 mb-2 p-1">
                        <Link
                          to={cmsData?.instagramLink}
                          target="_blank"
                          className="nav-link text-dark footer-text"
                        >
                          Instagram
                        </Link>
                      </li>
                    )}
                    {cmsData?.youtubeLink && (
                      <li className="mb-lg-3 mb-md-2 mb-2 p-1">
                        <Link
                          to={cmsData?.youtubeLink}
                          target="_blank"
                          className="nav-link text-dark footer-text"
                        >
                          Youtube
                        </Link>
                      </li>
                    )}
                  </ul>
                </div>
                <div className="col-lg-3 mb-lg-0 mb-md-3 mb-3">
                  <h6>Contact Us</h6>
                  <ul className="m-0 p-0 list">
                    <li className="mb-lg-3 mb-md-2 mb-2 p-1">
                      <Link
                        to="/contact"
                        className="nav-link text-dark footer-text"
                      >
                        Contact us
                      </Link>
                    </li>
                    {cmsData?.phoneNumber && (
                      <li className="mb-lg-3 mb-md-2 mb-2 p-1">
                        {cmsData.phoneNumber}
                      </li>
                    )}
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="copyright">
        <div className="container mx-auto p-4 text-center after-footer text-white">
          &copy; 2024 All rights reserved || powered by RA Kolkata Software
          Services Pvt. Ltd
        </div>
      </div>
    </div>
  );
};

export default Footer;
